/**
 * Resolve the Bayut KSA project unit-type fields that the `Property` table cell and the mobile
 * listing card read (`components/table/table-components/listing-purpose.js`,
 * `tenant/bayut/components/listing/listingCard.js`).
 *
 * These listings have no REGA path at all, so the cell shows the project's WAFI licence in place
 * of the REGA ID and must not fall back to the `Unlicensed` tag. Several unrelated transformers
 * build that cell — My Listings, the listing report, and the TruLeads "Interested In" tooltip —
 * so the resolution lives here rather than being repeated (and forgotten) in each of them.
 *
 * `is_unit_type_listing` is false on every non-unit-type listing and on every non-KSA tenant, so
 * callers can spread the result unconditionally.
 */
export const getUnitTypeListingDetails = (listing) => ({
  isUnitTypeListing: listing?.is_unit_type_listing === true,
  /** BE sends the licence on the project card or at the payload root, depending on the endpoint. */
  wafiLicense: listing?.project_detail_card?.project?.wafi_license ?? listing?.wafi_license ?? null,
  /** `off_plan` | `ready` — drives the state shown in the purpose tag. */
  unitTypeProjectStatus: listing?.project_detail_card?.project?.status ?? null,
});

export default getUnitTypeListingDetails;
